import type { Dictionnaire } from '../type';

export const lieux: Dictionnaire['lieux'] = {
  carte: 'خريطة الأماكن',
  filtrer: 'تصفية الأماكن',
  tout: 'الكل',
  rapproche: 'قرّب الخريطة لرؤية الأماكن',
  recherche: 'جارٍ البحث عن الأماكن…',
  fermer: 'إغلاق',
  appeler: 'اتصال',
  chercherSurLeWeb: 'البحث على الإنترنت',
  chercher: 'ابحث عن نوع نشاط',
  exemple: 'مسبح، ملعب…',
  effacer: 'مسح',
  rienTrouve: 'لم يتم العثور على شيء هنا',
  creerUnEvenement: 'أنشئ فعالية هنا',
  aimer: 'أعجبني هذا المكان',
  nePlusAimer: 'إلغاء الإعجاب بهذا المكان',
  familles: {
    restos: 'مطاعم',
    sorties: 'خروجات',
    sport: 'رياضة',
    culture: 'ثقافة',
    nature: 'طبيعة',
    commerces: 'متاجر',
  },
  categories: {
    Restaurant: 'مطعم',
    Cafe: 'مقهى',
    Bakery: 'مخبز',
    Nightlife: 'حانة',
    Brewery: 'مصنع جعة',
    Winery: 'مزرعة كروم',
    Distillery: 'معمل تقطير',
    MovieTheater: 'سينما',
    Theater: 'مسرح',
    MusicVenue: 'قاعة حفلات',
    Bowling: 'بولينغ',
    MiniGolf: 'غولف مصغر',
    GoKart: 'كارتينغ',
    AmusementPark: 'مدينة ملاهٍ',
    Stadium: 'ملعب',
    Soccer: 'كرة القدم',
    Tennis: 'تنس',
    Basketball: 'كرة السلة',
    Swimming: 'مسبح',
    Volleyball: 'كرة الطائرة',
    Golf: 'غولف',
    Skating: 'حلبة تزلج',
    RockClimbing: 'تسلق',
    SkatePark: 'حديقة تزلج',
    FitnessCenter: 'نادٍ رياضي',
    Museum: 'متحف',
    Landmark: 'معلم',
    Castle: 'قلعة',
    Fortress: 'حصن',
    NationalMonument: 'نصب وطني',
    Library: 'مكتبة',
    Planetarium: 'قبة فلكية',
    Aquarium: 'حوض مائي',
    Zoo: 'حديقة حيوان',
    Park: 'حديقة',
    Beach: 'شاطئ',
    Hiking: 'مشي لمسافات طويلة',
    NationalPark: 'حديقة وطنية',
    Marina: 'مرسى',
    Store: 'متجر',
    FoodMarket: 'سوق',
  },
};
